import { Client } from "allo-indexer-client";
import { renderToHTML } from "common";
import { utils } from "ethers";
import React from "react";
import useSWR from "swr";
import DefaultLogoImage from "../../assets/default_logo.png";
import { ProjectBanner } from "../common/ProjectBanner";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const boundFetch = fetch.bind(window);
export let VerifiedCredentialState = /*#__PURE__*/function (VerifiedCredentialState) {
  VerifiedCredentialState[VerifiedCredentialState["VALID"] = 0] = "VALID";
  VerifiedCredentialState[VerifiedCredentialState["INVALID"] = 1] = "INVALID";
  VerifiedCredentialState[VerifiedCredentialState["PENDING"] = 2] = "PENDING";
  return VerifiedCredentialState;
}({});
export const CalendarIcon = props => {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 0C3.44772 0 3 0.447715 3 1V2H2C0.895431 2 0 2.89543 0 4V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V4C16 2.89543 15.1046 2 14 2H13V1C13 0.447715 12.5523 0 12 0C11.4477 0 11 0.447715 11 1V2H5V1C5 0.447715 4.55228 0 4 0ZM4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H12C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5H4Z",
      fill: "#757087"
    })
  });
};
export function Header(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full xl:max-w-[1800px]",
    children: [/*#__PURE__*/_jsx(ProjectBanner, {
      bannerHash: props.bannerHash,
      classNameOverride: "h-32 w-full object-cover lg:h-80 rounded",
      resizeHeight: 320
    }), /*#__PURE__*/_jsx("div", {
      className: "pl-4 sm:pl-6 lg:pl-8",
      children: /*#__PURE__*/_jsx("div", {
        className: "-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5",
        children: /*#__PURE__*/_jsx("div", {
          className: "flex",
          children: /*#__PURE__*/_jsx(ProjectLogo, {
            logoHash: props.logoHash,
            classNameOverride: "h-24 w-24 rounded-full ring-4 ring-white bg-white sm:h-32 sm:w-32"
          })
        })
      })
    })]
  });
}
export function ProjectTitle(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "border-b-2 pb-4",
    children: /*#__PURE__*/_jsx("h1", {
      className: "text-3xl mt-6 font-thin text-black",
      children: props.title
    })
  });
}
export function DescriptionTitle(_ref) {
  let {
    title
  } = _ref;
  return /*#__PURE__*/_jsx("h1", {
    className: "text-2xl my-4 font-thin text-black",
    children: title || "Description"
  });
}
export function DetailSummary(props) {
  return /*#__PURE__*/_jsxs("p", {
    className: `${props.sm ? "text-sm" : "text-base"} font-normal text-black`,
    "data-testid": props.testID,
    children: [" ", props.text, " "]
  });
}
export function Detail(props) {
  return /*#__PURE__*/_jsx("p", {
    dangerouslySetInnerHTML: {
      __html: renderToHTML(props.text.replace(/\n/g, "\n\n"))
    },
    className: "text-md prose prose-h1:text-lg prose-h2:text-base prose-h3:text-base prose-a:text-blue-600 max-w-full",
    "data-testid": props.testID
  });
}
export function ApplicationFormAnswers(props) {
  const donationWallets = props.answers.filter(a => a.question === "Donation Wallets");
  // only show answers that are not empty and are not marked as hidden
  const answers = [...props.answers.filter(a => !!a.answer && !a.hidden), ...donationWallets];
  if (answers.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("h1", {
      className: "text-2xl mt-8 font-thin text-black",
      children: "Additional Information"
    }), /*#__PURE__*/_jsx("div", {
      children: answers.map(answer => {
        const answerText = Array.isArray(answer.answer) ? answer.answer.join(", ") : answer.answer;
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            className: "text-md mt-8 mb-3 font-semibold text-black",
            children: answer.question
          }), answer.type === "paragraph" ? /*#__PURE__*/_jsx("p", {
            dangerouslySetInnerHTML: {
              __html: renderToHTML(answerText.replace(/\n/g, "\n\n"))
            },
            className: "text-md prose prose-h1:text-lg prose-h2:text-base prose-h3:text-base prose-a:text-blue-600"
          }) : /*#__PURE__*/_jsx("p", {
            className: "text-base text-black",
            children: answerText.replace(/\n/g, "<br/>")
          })]
        }, answer.questionId);
      })
    })]
  });
}
export function ProjectLogo(props) {
  const {
    logoHash,
    classNameOverride
  } = props;
  const applicationLogoImage = logoHash ? `https://${process.env.REACT_APP_PINATA_GATEWAY}/ipfs/${logoHash}` : DefaultLogoImage;
  return /*#__PURE__*/_jsx("div", {
    className: "pl-4",
    children: /*#__PURE__*/_jsx("div", {
      className: "-mt-6 sm:-mt-6 sm:flex sm:items-end sm:space-x-5",
      children: /*#__PURE__*/_jsx("div", {
        className: "flex",
        children: /*#__PURE__*/_jsx("img", {
          className: classNameOverride !== null && classNameOverride !== void 0 ? classNameOverride : "h-12 w-12 rounded-full ring-4 ring-white bg-white",
          src: applicationLogoImage,
          alt: "Project Logo"
        })
      })
    })
  });
}

// NOTE: Consider moving this
export function useRoundApprovedApplication(chainId, roundId, projectId) {
  var _process$env$REACT_AP;
  // use chain id and project id from url params
  const client = new Client(boundFetch, (_process$env$REACT_AP = process.env.REACT_APP_ALLO_API_URL) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : "", chainId);
  return useSWR([roundId, "/projects"], async _ref2 => {
    let [roundId] = _ref2;
    const applications = await client.getRoundApplications(utils.getAddress(roundId.toLowerCase()));
    return applications.find(app => app.projectId === projectId && app.status === "APPROVED");
  });
}